import { Box } from '@mui/material'
import { Pretest }  from './Pretest'
import { Info } from './Info'
import { ToolContext } from '../../../../../core/context/ToolContext'
import { useContext, useState } from 'react'
import { Quiz } from './Quiz'
import { PostEval } from './PostEval'
import { VL } from './VL'
import { useHistory } from "react-router-dom";
import { useEffect } from 'react'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const TakeTrainings = ({match}) => {
    const __LOCATION = window.location.pathname;
    const { tab } = match.params
    const { navigation_state, information_state, tool_state, certificates_state } = useContext(ToolContext)
    const { openWidth, __SESSION: {data: { ainfo }}, info} = {...navigation_state, ...tool_state, ...certificates_state}
    const uid = window.atob(ainfo.aid).split('_').pop()
    const l = {pretest:Pretest, quiz: Quiz, 'post-evaluation': PostEval, 'video-lesson':VL}
    const List = l[tab]
    const nav = useHistory()
    let urlParams = new URLSearchParams(window.location.search);
    const [ title, setTitle] = useState('')
    
    const wideHandler = () => {
        openWidth.set(!openWidth.data);
    };

    const __init = async(id) => {
        // Fetch the base data for all validations
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {
            training_id: id,
            ref: 'trainings',
            company_id: tool_state.cinfo.data[0].company_id
        });
        
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {
            training_id: id,
            user_id: uid,
            ref: 'trainings',
            company_id: tool_state.cinfo.data[0].company_id
        });

        // Determine available components
        const available = {
            pretest: tContent[0].pretest_id !== null,
            quiz: tContent[0].quiz_id !== null,
            postEval: tContent[0].post_evaluation_id !== null,
            videoLesson: tContent[0].mode_of_conduct !== 2 // Only if not webinar mode
        };

        // Determine completed progress
        const done = {
            pretest: progress.some(p => p.exam_type === 1 && p.progress_status === 1),
            quiz: progress.some(p => p.exam_type === 2 && p.progress_status === 1),
            postEval: progress.some(p => p.exam_type === 3 && p.progress_status === 1),
            videoLesson: progress.some(p => p.exam_type === 4 && p.progress_status === 1)
        };

        // Map available sequence order
        const sequence = [
            available.pretest && 'pretest',
            available.videoLesson && 'video-lesson',
            available.quiz && 'quiz',
            available.postEval && 'post-evaluation'
        ].filter(Boolean); // remove false

        // Find what page user is trying to open
        const currentTab = tab; // e.g. "video-lesson", "quiz", etc.
        const currentIndex = sequence.indexOf(currentTab);

        // Validation 1: Does this tab even exist?
        if (currentIndex === -1) {
            const previousSteps = sequence.slice(0, currentIndex);
            const allPrevDone = previousSteps.every(step => {
                if (step === 'pretest') return done.pretest;
                if (step === 'video-lesson') return done.videoLesson;
                if (step === 'quiz') return done.quiz;
                if (step === 'post-evaluation') return done.postEval;
                return true;
            });
            if (!allPrevDone) {
                const nextIncomplete = previousSteps.find(step => {
                    if (step === 'pretest') return !done.pretest;
                    if (step === 'video-lesson') return !done.videoLesson;
                    if (step === 'quiz') return !done.quiz;
                    if (step === 'post-evaluation') return !done.postEval;
                });
                alert("This step is not available for this training.");
                nav.push(`/biz/take-training/${nextIncomplete}?id=${id}`);
                return;
            }
        }

        // Validation 2: Are previous steps completed?
        const previousSteps = sequence.slice(0, currentIndex);
        const allPrevDone = previousSteps.every(step => {
            if (step === 'pretest') return done.pretest;
            if (step === 'video-lesson') return done.videoLesson;
            if (step === 'quiz') return done.quiz;
            if (step === 'post-evaluation') return done.postEval;
            return true;
        });

        if (!allPrevDone) {
            const nextIncomplete = previousSteps.find(step => {
                if (step === 'pretest') return !done.pretest;
                if (step === 'video-lesson') return !done.videoLesson;
                if (step === 'quiz') return !done.quiz;
                if (step === 'post-evaluation') return !done.postEval;
            });
            alert("You must complete the previous step first.");
            nav.push(`/biz/take-training/${nextIncomplete}?id=${id}`);
            return;
        }

        let init;
        if (tab === 'pretest') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_pretest`, { training_id: id });
        } else if (tab === 'video-lesson') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_VL`, {training_id:id, company_id: tool_state.cinfo.data[0].company_id})

        } else if (tab === 'quiz') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_Quiz`, {training_id:id})

        } else {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_PostEvaluation`, {training_id:id})
        }
        setTitle(init.title)
        
    }
    useEffect(() => {
        __init(urlParams.get('id'))
    }, [])

    return (
        <>
            <Box width="100%" bgcolor="#F5F8FF" px="40px" py="10px">
                <Box display="flex" alignItems="center">
                    <Box fontSize={14} fontWeight={400} color="#1893F1">Trainings</Box>
                    <Box mx="19.5px">
                        <ArrowForwardIosIcon sx={{ fontSize: 11 }} /> 
                    </Box>
                    <Box fontSize={14} fontWeight={400} >{title}</Box>
                </Box>
            </Box>
            <Box display="flex" flexDirection="row" flex={1} width="100%">
                <List openWidth={openWidth} wideHandler={wideHandler} uid={uid} information_state={information_state} nav={nav} info={info} tool_state={tool_state}/>
                <Info openWidth={openWidth} wideHandler={wideHandler} __LOCATION={__LOCATION} uid={uid} information_state={information_state} tool_state={tool_state}/>
            </Box> 
        </>
    )
}

export default TakeTrainings;